import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'

import { TableCell } from '@mui/material'
import { DateTimeCompactField, TextField, ModelAutocompleteField } from '@front/squirtle'

import { TextCell } from '@abra/elements/table/cells/basics/'
import { UserUtils } from '@front/volcanion/utils'

const Row = () => {
  const operator = hooks.useLocalFieldValue('operator')
  const [{ name: operator_name }] = hooks.useCustomerInfo(operator?.user_id || operator)

  const autocompleteMutatorCustomer = useCallback(q => {
    const tokens = _.compact(_.split(_.trim(q || ''), ' '))
    if (_.isEmpty(tokens)) return undefined
    const clauses = tokens.map(tok => ({
      or: [
        { customerinfo: { client_number: { startsWith: tok } } },
        { info: { first_name: { startsWith: tok } } },
        { info: { last_name: { startsWith: tok } } }
      ]
    }))
    return tokens.length === 1 ? clauses[0] : { and: clauses }
  }, [])

  return <>
    <TableCell size={'small'}>
      <DateTimeCompactField
        name={'createdAt'}
        inputFormat={'DD/MM/YYYY HH:mm'}
        disabled
        renderInputProps={{
          inputProps: { style: { textAlign: 'center' } }
        }}
        disableOpenPicker
      />
    </TableCell>
    <TableCell size={'small'}>
      <TextCell value={operator_name} />
    </TableCell>
    <TableCell size={'small'} sx={{ width: 1 / 3 }}>
      <ModelAutocompleteField
        name={'customer'}
        model_name='user'
        config={{
          populate: ['customerinfo', 'info'],
          mutator: user => ({
            label: UserUtils.getFormatedName(
              { ...user.info, designation: user?.customerinfo?.name },
              { prefix: user?.customerinfo?.client_number, separator: ' ' }
            ),
            ...user
          })
        }}
        autocompleteMutator={autocompleteMutatorCustomer}
        multiple={false}
        searchMode='search'
        allowNone={false}
        loadOnFocus
        loadOnMount
      />
    </TableCell>
    <TableCell size={'small'}><TextField name={'reason'} /></TableCell>
  </>
}

export default React.memo(Row)
